/**
 * PDP Perfect Pairing Button
 *
 * Handles adding the paired FishLab variant to the cart
 * when the user clicks the price button.
 */

class PdpPerfectPairingButton extends HTMLElement {
  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.btn = this.querySelector('[data-add-pairing]');
    this.abortController = new AbortController();

    if (this.btn && this.variantId) {
      this.btn.addEventListener('click', () => this.addToCart(), { signal: this.abortController.signal });
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  async addToCart() {
    if (!window.PdpUtils) return;
    await window.PdpUtils.addToCart(parseInt(this.variantId, 10), 1, this.btn, this);
  }
}

if (!customElements.get('pdp-perfect-pairing-button')) {
  customElements.define('pdp-perfect-pairing-button', PdpPerfectPairingButton);
}
